module.exports = __webpack_public_path__ + "img/moxa.5917c8c4.png";